module.exports = __webpack_public_path__ + "img/dzsw-01.bf9919ec.png";